import { HttpResponse, type HttpResponseResolver } from 'msw';
import { datasetOptions } from './__mocks__/datasets';

export const mockDatasetsEndpoint: HttpResponseResolver = () => {
  return HttpResponse.json({
    datasets: datasetOptions,
  });
};
